<template>
    <div>
        <div v-for="(item,index) in ifilter" :key="index" style="margin-top:10px;margin-bottom:20px">
            {{item}}
        </div>
        <el-row>
          <el-col :span="8" v-for="(item,index) in filterCards" :key="index">
            <el-card style="height: 620px" shadow="hover">
              <div slot="header" v-html="item.name"></div>
              <p v-for="(subItem,index2) in item.desc" :key="index2">{{subItem}}</p>
            </el-card>
          </el-col>
        </el-row>
        <div style="margin-top: 30px">{{ $t('link.title') }}</div>
        <div class="linkContainer">
          <div v-for="(chunk, ci) in linkChunks" :key="ci">
            <a v-for="(lnk, li) in chunk" :key="li" :href="lnk.href">{{ lnk.label }}</a><br>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  data: function () {
    return {
    }
  },
  computed: {
    ifilter () {
      return this.$t('link.ifilter')
    },
    filterCards () {
      return this.$t('link.filterCards')
    },
    linkChunks () {
      const links = this.$t('link.links') || []
      const size = Math.ceil(links.length / 3)
      const chunks = []
      for (let i = 0; i < links.length; i += size) {
        chunks.push(links.slice(i, i + size))
      }
      return chunks
    }
  }
}
</script>

<style scoped>
.linkContainer {
  width: 100%;
  display: flex;
  /* flew-direction: row */
  text-align: center;
}

.linkContainer>div{
  flex: 1;
}

.linkContainer>div>a{
  display: inline-block;
  margin-top: 10px;
}
</style>
